import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import api, { setErrors } from '@/middlewares/api';
import SavedInfoModal from '@/components/modals/saved';
import PasswordField from '@/components/forms/password-field';

class ChangePasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenModal: false,
            isQuery: false,
            error: null
        }
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    onCloseModal() {
        this.setState({
            isOpenModal: false,
        });
    }

    handleFormSubmit(data) {
        this.setState({
            isQuery: true,
            error: null
        });

        return new Promise((resolve, reject) => {
            // First verify current password and get Auth0 token
            api.post('auth/verify-password', {
                email: localStorage.getItem('user_email'), // Assuming email is stored in localStorage
                password: data.current_password
            })
            .then(response => {
                // If current password is verified, proceed with password update
                return api.post('auth/change-password', {
                    current_password: data.current_password,
                    new_password: data.password,
                    password_confirmation: data.password_confirmation
                });
            })
            .then((response) => {
                this.setState({
                    isOpenModal: true,
                    isQuery: false,
                });
                this.props.reset();
                return resolve(null);
            })
            .catch((err) => {
                this.setState({
                    isQuery: false,
                    error: err.response?.data?.message || 'An error occurred while updating password'
                });

                if (!err.response) return;
                
                if (err.response.status === 401) {
                    return reject({ current_password: 'Current password is incorrect' });
                }
                
                if (err.response.status === 422) {
                    return reject(setErrors(err.response));
                }

                return reject({ _error: 'Failed to update password. Please try again.' });
            });
        });
    }

    render() {
        const { handleSubmit } = this.props;
        const { isOpenModal, isQuery, error } = this.state;
        
        return (
            <Fragment>
                <form onSubmit={handleSubmit((data) => {
                    return this.handleFormSubmit(data);
                })} className="profile-form" noValidate>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <div className="form-row">
                        <div className="form-col_2">
                            <Field
                                name="current_password"
                                component={PasswordField}
                                label="Current Password"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-col_2">
                            <Field
                                name="password"
                                component={PasswordField}
                                label="New Password"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-col_2">
                            <Field
                                name="password_confirmation"
                                component={PasswordField}
                                label="Confirm New Password"
                            />
                        </div>
                    </div>
                    <div className="submit-row">
                        <button 
                            className="btn btn-primary" 
                            disabled={isQuery}
                            type="submit"
                        >
                            {isQuery ? 'Updating Password...' : 'Update Password'}
                        </button>
                    </div>
                </form>
                <SavedInfoModal 
                    open={isOpenModal} 
                    onClose={this.onCloseModal}
                    message="Your password has been successfully updated"
                />
            </Fragment>
        )
    }
}

const validate = values => {
    const errors = {};
    
    if (!values.current_password) {
        errors.current_password = 'Current password is required';
    }
    
    if (!values.password) {
        errors.password = 'New password is required';
    } else if (values.password.length < 8) {
        errors.password = 'Password must be at least 8 characters long';
    }
    
    if (!values.password_confirmation) {
        errors.password_confirmation = 'Password confirmation is required';
    } else if (values.password !== values.password_confirmation) {
        errors.password_confirmation = 'Passwords do not match';
    }
    
    return errors;
};

const ChangePasswordFormWrapped = reduxForm({
    form: 'dashboard-security-password-form',
    validate
})(ChangePasswordForm);

export default ChangePasswordFormWrapped;
